import Login from 'features/auth/login/Login';
import React from 'react';

export default function LoginScreen() {
  return <Login />;
}
